import React from 'react';
import {
  footerStyle,
  lwtLinkContainerStyle,
  lwtLinkStyle,
  smallTextStyle,
  smallLinkStyle
} from './styles/Footer.css';

const Footer = () => {
  return (
    <footer style={footerStyle}>
      <div className="container">
        <div style={lwtLinkContainerStyle}>
          <a style={lwtLinkStyle} href="https://www.lwolf.com/" target="new">
            Lone Wolf Technologies
          </a>
        </div>
        <div style={smallTextStyle}>
          This product is part of the Lone Wolf family of real estate products.
          <a
            style={smallLinkStyle}
            href="https://www.lwolf.com/contact"
            target="new"
          >
            {' Contact us '}
          </a>
          to learn more. © Lone Wolf Technologies 2017.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
